/*
 * @Descripttion: 将@/components/* 目录下的组件，按照文件名称，注册到Vue中
 */
const files = require.context('@/components', false, /\.vue$/)
const components = {}
files.keys().forEach((key) => {
  components[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default
})
export default {
  install(Vue) {
    for (let key in components) {
      Vue.component(key, components[key])
    }
  },
}
